import ProfileMenuAdmin from '@/components/ProfileMenu/ProfileMenuAdmin.tsx'
import { Spin } from 'antd'
import { useAppContext } from 'common/context/AppContext.tsx'
import { CommonRoutes, getBaseRoute, getRouteActionTitle, getRouteTitleAlias, normalizeRoutePath } from 'common/context/commonRoutes.ts'
import { useUserContext } from 'common/context/UserContext.tsx'
import * as React from 'react'
import { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'

import './style.css'
import { menuTabs } from '@/components/sidebar/sidebarTabsAdmin.tsx'

interface BreadcrumbProps {
  collapsed: boolean
}

export const BreadcrumbAdmin: React.FC<BreadcrumbProps> = ({ collapsed }) => {
  const [breadcrumb, setBreadcrumb] = useState<React.ReactNode[]>([])
  const location = useLocation()
  const { blackTheme } = useUserContext()
  const { preloader, contextHolder } = useAppContext()

  const menuTitleByKey = React.useMemo(() => {
    const map = new Map<string, string>()
    const traverse = (items: any[]) => {
      items.forEach((item) => {
        if (item?.url && item?.label) {
          map.set(normalizeRoutePath(item.url), item.label)
        }
        if (item.children?.length) {
          traverse(item.children)
        }
      })
    }
    traverse(menuTabs as any[])
    return map
  }, [])

  const getItemName = React.useCallback(
    (pathname: string) => {
      return getRouteTitleAlias(pathname) || menuTitleByKey.get(pathname) || 'Dashboard'
    },
    [menuTitleByKey],
  )

  const buildBreadcrumb = React.useCallback(() => {
    const pathParts = location.pathname.split('/').filter(Boolean)
    const sectionRoute = getBaseRoute(location.pathname)

    const crumbs: React.ReactNode[] = []

    // Home
    crumbs.push(
      <Link key="home" className="breadcrumbBar__item" to="/">
        Home
      </Link>,
    )

    if (pathParts.length > 0) {
      const sectionName = getItemName(sectionRoute)
      crumbs.push(<span className="breadcrumbBar__arrow" key="arrow1" />)
      crumbs.push(
        <Link key="section" className="breadcrumbBar__item" to={sectionRoute === CommonRoutes.PROFILE ? location.pathname : sectionRoute}>
          {sectionName}
        </Link>,
      )
    }

    // Actions: create / edit / copy
    if (pathParts.some((p) => ['create', 'edit', 'copy'].includes(p))) {
      const action = pathParts.find((p) => ['create', 'edit', 'copy'].includes(p))
      if (action) {
        const actionLabel = action === 'create' ? 'New' : action === 'edit' ? 'Edit' : action === 'copy' ? 'Copy' : ''
        const entityName = getRouteActionTitle(sectionRoute, getItemName(sectionRoute))
        crumbs.push(<span className="breadcrumbBar__arrow" key="arrow2" />)
        crumbs.push(
          <span key="action" className="breadcrumbBar__item">
            {actionLabel} {entityName}
          </span>,
        )
      }
    }

    return crumbs
  }, [location.pathname, getItemName])

  useEffect(() => {
    setBreadcrumb(buildBreadcrumb())
  }, [buildBreadcrumb])

  return (
    <div
      className={`breadcrumbBar ${blackTheme ? 'breadcrumb_black' : 'breadcrumb_white'}`}
      style={{
        width: `calc(100% - ${collapsed ? 80 : 214}px)`,
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <div
          className={`breadcrumbBar__path ${blackTheme ? 'breadcrumbBar__path_black' : 'breadcrumbBar__path_white'}`}
          style={{ display: 'inline-block' }}
        >
          {breadcrumb}
        </div>
        {preloader && (
          <div
            style={{
              marginLeft: '10px',
              minWidth: '120px',
              minHeight: '32px',
              display: 'flex',
              alignItems: 'center',
              flexShrink: 0,
            }}
          >
            <Spin tip="Loading" size="large" />
          </div>
        )}
      </div>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: 60,
        }}
      >
        <ProfileMenuAdmin />
      </div>
      {contextHolder}
    </div>
  )
}
